import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["helperText", "children", "variant", "hasMinWidth", "size", "href", "className", "fullWidth", "palette"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { defaultProps } from "./constants";
import { ButtonElement, ButtonWrapper, ButtonHelperText } from "./button.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Button = function Button(_ref) {
  var helperText = _ref.helperText,
    children = _ref.children,
    variant = _ref.variant,
    hasMinWidth = _ref.hasMinWidth,
    size = _ref.size,
    href = _ref.href,
    className = _ref.className,
    fullWidth = _ref.fullWidth,
    palette = _ref.palette,
    buttonElementProps = _objectWithoutProperties(_ref, _excluded);
  var anchorOrButtonElement = href ? 'a' : 'button';
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    className: className,
    fullWidth: fullWidth,
    variant: variant,
    hasMinWidth: hasMinWidth,
    size: size,
    children: [/*#__PURE__*/_jsx(ButtonElement, _objectSpread(_objectSpread({}, buttonElementProps), {}, {
      palette: palette,
      size: size,
      variant: variant,
      href: href,
      as: anchorOrButtonElement,
      children: children
    })), helperText && /*#__PURE__*/_jsx(ButtonHelperText, {
      palette: palette,
      children: helperText
    })]
  });
};
Button.defaultProps = defaultProps;
export default Button;